export const AREA_CODES = [
	"0296", // An Giang
	"0254", // Ba Ria - Vung Tau
	"0204", // Bac Giang
	"0209", // Bac Kan
	"0291", // Bac Lieu
	"0222", // Bac Ninh
	"0275", // Ben Tre
	"0256", // Binh Dinh
	"0274", // Binh Duong
	"0271", // Binh Phuoc
	"0252", // Binh Thuan
	"0290", // Ca Mau
	"0292", // Can Tho
	"0206", // Cao Bang
	"0236", // Da Nang
	"0262", // Dak Lak
	"0261", // Dak Nong
	"0215", // Dien Bien
	"0251", // Dong Nai
	"0277", // Dong Thap
	"0269", // Gia Lai
	"0219", // Ha Giang
	"0226", // Ha Nam
	"0242", // Ha Noi
    "0243", // Ha Noi
    "0244", // Ha Noi
    "0245", // Ha Noi
    "0246", // Ha Noi
    "0247", // Ha Noi
    "0248", // Ha Noi
	"0239", // Ha Tinh
	"0220", // Hai Duong
	"0225", // Hai Phong
	"0293", // Hau Giang
	"0218", // Hoa Binh
	"0221", // Hung Yen
	"0258", // Khanh Hoa
	"0297", // Kien Giang
	"0260", // Kon Tum
	"0213", // Lai Chau
	"0263", // Lam Dong
	"0205", // Lang Son
	"0214", // Lao Cai
	"0272", // Long An
	"0228", // Nam Dinh
	"0238", // Nghe An
	"0229", // Ninh Binh
	"0259", // Ninh Thuan
	"0210", // Phu Tho
	"0257", // Phu Yen
	"0232", // Quang Binh
	"0235", // Quang Nam
	"0255", // Quang Ngai
	"0203", // Quang Ninh
	"0233", // Quang Tri
	"0299", // Soc Trang
	"0212", // Son La
	"0276", // Tay Ninh
	"0227", // Thai Binh
	"0208", // Thai Nguyen
	"0237", // Thanh Hoa
	"0234", // Thua Thien - Hue
	"0273", // Tien Giang
	"0282", // TP. Ho Chi Minh
    "0283", // TP. Ho Chi Minh
    "0284", // TP. Ho Chi Minh
    "0285", // TP. Ho Chi Minh
    "0286", // TP. Ho Chi Minh
    "0287", // TP. Ho Chi Minh
	"0294", // Tra Vinh
	"0207", // Tuyen Quang
	"0270", // Vinh Long
	"0211", // Vinh Phuc
	"0216", // Yen Bai
];

export const REGION_INDEX_TO_PROVINCE_INDEX = [ 
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], [18], [19],
    [20], [21], [22], [23, 24, 25, 26, 27, 28, 29], [30], [31], [32], [33], [34], [35], [36], [37],
    [38], [39], [40], [41], [42], [43], [44], [45], [46], [47], [48], [49], [50], [51], [52], [53], [54], [55],
    [56], [57], [58], [59], [60], [61], [62], [63, 64, 65, 66, 67, 68], [69], [70], [71], [72], [73],
];